import { isEmpty, pick } from 'lodash'
import { observable, action } from 'mobx'
import moment from 'moment'
import { Request2 } from 'src/common/Request2'
import api from 'src/common/api'
import { ROLE } from 'src/helpers/constants'

export const jobDetailInit = {
   id: 0,
   name: '',
   count: 1,
   designTypeId: undefined,
   productTypeId: undefined,
   note: '',
   images: [],
   tag: '',
   avatar: '',
   status: 0,
   creatorId: 0,
   designerId: 0,
   price: 0,
   actuallyReceived: 0,
   totalActuallyReceived: 0,
   totalPrice: 0,
   url: '',
   // Link ban thiet ke + ten seller: admin/supporter nhap o popup chi tiet
   linkDesign: '',
   seller: '',
   sellerOrderId: '',
   // Ten san pham cua don, Zenith gui kem luc tao viec
   productName: '',
   linkMockup: '',
   // Ghi chu admin/supporter, dong bo sang orders.note1 ben Zenith
   note1: '',
   // So mui theu: designer cua viec nhap, null = chua nhap
   totalStitches: null as number | null,
   newStitches: null as number | null,
   countReject: 0,
   startedAt: '',
   expiresAt: '',
   deletedAt: '',
   createdAt: '',
   updatedAt: '',
   isPriority: '',
   target: null,
   targetId: undefined,
   targetIdSave: undefined,
   productType: {
      id: null,
      name: null,
      countJob: null,
      deletedAt: null,
      createdAt: null,
      updatedAt: null
   },
   designType: {
      id: null,
      name: '',
      countJob: 0,
      deletedAt: null,
      createdAt: null,
      updatedAt: null
   },
   creator: {
      name: '',
      avatar: '',
      email: ''
   },
   designer: {
      name: '',
      avatar: '',
      email: ''
   }
}

// Cac truong admin/supporter sua tren popup chi tiet, luu bang API /job/manager-update
const MANAGER_TEXT_FIELDS = ['note', 'note1', 'linkDesign', 'linkMockup', 'seller', 'sellerOrderId', 'productName']
const STITCHES_FIELDS = ['totalStitches', 'newStitches']

export class JobDetailStore {
   @observable jobDetail = { ...jobDetailInit }
   // Truong da sua tren popup ma chua luu -> bam Hoan thanh / Review se luu luon
   @observable dirtyFields: string[] = []
   @observable imageUrls: string[] = []
   @observable uploadUrls: string[] = []
   @observable comments: any[] = []

   @action setComments = (comments: any[]) => {
      this.comments = [...comments]
   }

   @action setNewComment = (newComment: any, role: string) => {
      let fromId
      if (role === ROLE.CREATOR) {
         fromId = this.jobDetail.creatorId
      } else if (role === ROLE.DESIGNER) {
         fromId = this.jobDetail.designerId
      }

      let isMyMessage = newComment?.from === fromId
      if (!isMyMessage) {
         console.log('newcomment')
         this.comments = [...this.comments, { ...newComment, createdAt: moment.now() }]
      }
   }

   @action setImageUrls = (imgs: string[]) => {
      this.imageUrls = [...imgs]
   }

   @action setUploadUrls = (imgs: string[]) => {
      this.uploadUrls = [...imgs]
   }

   @action setJobDetail = (jobDetail: any) => {
      console.log('====================================');
      console.log("jobDetailjobDetail", JSON.stringify(jobDetail));
      console.log('====================================');
      this.jobDetail = { ...jobDetail }
   }

   @action setJobDetailName = (name: any) => {
      this.jobDetail.name = name
   }

   @action setJobDetailImages = (images: any) => {
      this.jobDetail.images = images
   }

   @action setJobDetailDescription = (description: any) => {
      this.jobDetail.note = description
   }
   @action setJobDetailTargetId = (targetId: any) => {
      this.jobDetail.targetId = targetId
   }
   @action setJobDetailProductTypeId = (productTypeId: any) => {
      this.jobDetail.productTypeId = productTypeId
   }

   @action setJobDetailDesignTypeId = (designTypeId: any) => {
      this.jobDetail.designTypeId = designTypeId
   }
   @action setTrustDesigner = (targetId: any) => {
      this.jobDetail.targetId = targetId
   }

   @action setJobDetailPrice = (price: any) => {
      this.jobDetail.price = price
   }

   @action setJobDetailTag = (tag: any) => {
      this.jobDetail.tag = tag ? tag?.join(', ') : ''
   }

   @action setJobDetailCount = (count: any) => {
      this.jobDetail.count = count
   }

   @action setJobDetailUrl = (url: any) => {
      this.jobDetail.url = url
   }

   @action setJobDetailLinkDesign = (linkDesign: any) => {
      this.jobDetail.linkDesign = linkDesign
   }

   @action setJobDetailSeller = (seller: any) => {
      this.jobDetail.seller = seller
   }

   @action setJobDetailSellerOrderId = (sellerOrderId: any) => {
      this.jobDetail.sellerOrderId = sellerOrderId
   }

   @action setJobDetailProductName = (productName: any) => {
      this.jobDetail.productName = productName
   }

   @action setJobDetailNote1 = (note1: any) => {
      this.jobDetail.note1 = note1
   }

   @action setJobDetailLinkMockup = (linkMockup: any) => {
      this.jobDetail.linkMockup = linkMockup
   }

   @action setJobDetailStitches = (data: { totalStitches?: number | null; newStitches?: number | null }) => {
      Object.assign(this.jobDetail, data)
   }

   @action markFieldDirty = (field: string) => {
      if (!this.dirtyFields.includes(field)) this.dirtyFields = [...this.dirtyFields, field]
   }

   @action clearDirtyFields = (fields?: string[]) => {
      this.dirtyFields = fields ? this.dirtyFields.filter((field) => !fields.includes(field)) : []
   }

   isFieldDirty = (...fields: string[]) => fields.some((field) => this.dirtyFields.includes(field))

   // Server tra ve job moi -> giu lai cac truong dang sua do chua luu, tranh mat noi dung o khoi khac
   @action applyServerJob = (job: any) => {
      this.jobDetail = { ...job, ...pick(this.jobDetail, this.dirtyFields) }
   }

   /**
    * Luu tat ca truong dang sua do truoc khi bam Hoan thanh / Can sua lai / Review.
    * Admin/supporter: gui chung 1 lan qua /job/manager-update. Designer: chi luu mui theu + note1.
    * Tra ve false neu luu loi de dung lai, khong chay tiep thao tac.
    */
   @action
   async saveDirtyFields(id: number, isManager: boolean) {
      const fields = isManager
         ? this.dirtyFields.filter((field) => [...MANAGER_TEXT_FIELDS, ...STITCHES_FIELDS].includes(field))
         : this.dirtyFields.filter((field) => [...STITCHES_FIELDS, 'note1'].includes(field))
      if (fields.length === 0) return true
      const jobDetail: any = this.jobDetail
      if (!isManager) {
         if (fields.includes('note1') && !(await this.updateNote1(id, (jobDetail.note1 || '').trim()))) return false
         if (!fields.some((field) => STITCHES_FIELDS.includes(field))) return true
         const response = await this.updateStitches(id, {
            totalStitches: jobDetail.totalStitches ?? null,
            newStitches: jobDetail.newStitches ?? null
         })
         return !!response
      }
      const data: any = {}
      fields.forEach((field) => {
         data[field] = MANAGER_TEXT_FIELDS.includes(field) ? (jobDetail[field] || '').trim() : jobDetail[field] ?? null
      })
      const response = await this.updateJobInfoByManager(id, data, fields)
      return !!response
   }

   @action setJobDetailStatus = (status: any) => {
      this.jobDetail.status = status
   }

   @action
   async getJobDetail(id: number) {
      const response = await Request2.getWithToken(api.job.getDetail + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = response
         this.dirtyFields = []
      }
      return response
   }

   @action
   async getExchangeFee(params: any) {
      const response = await Request2.getWithTokenNoMessage(api.exchangeFee.getFeeInfo, params)
      if (!isEmpty(response)) {
         this.jobDetail = response
      }
   }

   @action
   async getLastJob() {
      const response = await Request2.getWithToken(api.job.lastJob)
      if (!isEmpty(response)) {
         this.jobDetail = response
         console.log('jobDetail', response);

      }
      return response
   }

   @action
   async postJob(data: any) {
      const response = await Request2.postWithToken(data, api.job.getList)
      console.log('response', JSON.stringify(response));

      if (!isEmpty(response)) {
         this.jobDetail = response.data
      }
      return response
   }

   @action
   async postJobReceive(id: number) {
      const response = await Request2.postWithToken({}, api.job.receive + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = response.data
      }
   }

   @action
   async postJobReview(id: number) {
      const response = await Request2.postWithToken({}, api.job.review + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = response.data
      }
   }

   @action
   async postJobReReceive(id: number) {
      const response = await Request2.postWithToken({}, api.job.reReceive + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = response.data
      }
   }

   @action
   async postJobConfirm(id: number, status: boolean) {
      const response = await Request2.postWithToken({ reject: status }, api.job.confirm + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = response.data
      }
   }

   @action
   async postDesignerUpdateURL(id: number, url: string) {
      const response = await Request2.postWithToken({ url: url }, api.job.designerUpdateUrl + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = response.data
      }
      return response
   }

   /**
    * Admin/supporter tu dong viec. Url do quan tri vien nhap duoc luu cung luc.
    */
   @action
   async finishJobByAdmin(id: number, url: string) {
      const response = await Request2.postWithToken({ url }, api.job.approveFinish + `/${id}`)
      if (!isEmpty(response?.data)) {
         this.jobDetail = response.data
      }
      return response
   }

   /**
    * Admin/supporter trả kết quả về cho designer sửa lại (việc đang chờ review).
    */
   @action
   async rejectJobByManager(id: number) {
      const response = await Request2.postWithToken({}, api.job.managerReject + `/${id}`)
      if (!isEmpty(response?.data)) {
         this.jobDetail = response.data
      }
      return response
   }

   /**
    * Gợi ý link thiết kế tìm theo ảnh của việc (admin/supporter).
    */
   @action
   async getSuggestions(jobId: number) {
      return await Request2.getWithToken(api.job.suggestions + `/${jobId}`)
   }

   @action
   async refreshSuggestions(jobId: number) {
      const response = await Request2.postWithToken({}, api.job.suggestions + `/${jobId}/refresh`)
      return response?.data
   }

   /**
    * Duyệt gợi ý: server thêm link folder vào url của việc, trả về { job, suggestions }.
    */
   @action
   async applySuggestion(suggestionId: number) {
      const response = await Request2.postWithToken({}, api.job.applySuggestion + `/${suggestionId}`)
      if (!isEmpty(response?.data?.job)) {
         this.jobDetail = response.data.job
      }
      return response?.data
   }

   @action
   async rejectSuggestion(suggestionId: number) {
      const response = await Request2.postWithToken({}, api.job.rejectSuggestion + `/${suggestionId}`)
      return response?.data
   }

   /**
    * Designer của việc (hoặc admin/supporter) lưu tổng số mũi thêu / số mũi thêu mới.
    */
   @action
   async updateStitches(id: number, data: { totalStitches: number | null; newStitches: number | null }) {
      const response = await Request2.postWithToken(data, api.job.updateStitches + `/${id}`)
      if (!isEmpty(response?.data)) {
         this.clearDirtyFields(STITCHES_FIELDS)
         this.applyServerJob(response.data)
      }
      return response
   }

   /**
    * Designer của việc (hoặc admin/supporter) sửa note1, server đồng bộ sang Zenith.
    */
   @action
   async updateNote1(id: number, note1: string) {
      const response = await Request2.postWithToken({ note1 }, api.job.updateNote1 + `/${id}`)
      if (!isEmpty(response?.data)) {
         this.clearDirtyFields(['note1'])
         this.applyServerJob(response.data)
      }
      return response
   }

   /**
    * Admin/supporter lưu link design / seller / url. Chỉ gửi trường cần đổi,
    * trường không gửi thì server giữ nguyên giá trị cũ. `savedFields`: các trường vừa lưu
    * (mặc định = các key của data) -> bỏ khỏi danh sách đang sửa dở.
    */
   @action
   async updateJobInfoByManager(id: number, data: any, savedFields: string[] = Object.keys(data)) {
      const response = await Request2.postWithToken(data, api.job.managerUpdate + `/${id}`)
      if (!isEmpty(response?.data)) {
         this.clearDirtyFields(savedFields)
         this.applyServerJob(response.data)
      }
      return response
   }

   @action
   async updateJob(id: number, data: any) {
      const response = await Request2.postWithToken(data, api.job.update + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = response.data
      }
      return response
   }

   // Luu ngay danh sach anh (them anh / dat thumbnail). Chi cap nhat images de khong mat cac o dang sua do
   @action
   async updateJobImages(id: number, images: any[]) {
      const response = await Request2.postWithToken({ images }, api.job.updateImages + `/${id}`)
      if (response?.data?.images) {
         this.jobDetail.images = response.data.images
      }
      return response
   }

   // Hashtag vua duoc luu (tu popup hoac tu bang) -> cap nhat neu dung job dang mo. Chi doi tag de khong mat cac o dang sua do
   @action
   setTagOfJob(id: number, tag: string) {
      if (this.jobDetail?.id === id) {
         this.jobDetail.tag = tag
      }
   }

   // Sua so luong mau: server tinh lai tong tien va tru / hoan chenh lech vao vi creator
   @action
   async updateCount(id: number, count: number) {
      const response = await Request2.postWithToken({ count }, api.job.updateCount + `/${id}`)
      if (response?.data && this.jobDetail?.id === id) {
         const { totalPrice, totalActuallyReceived } = response.data
         this.jobDetail = { ...this.jobDetail, count: response.data.count, totalPrice, totalActuallyReceived }
      }
      return response
   }

   @action
   async deleteJob(id: number) {
      const response = await Request2.postWithToken({}, api.job.delete + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = { ...jobDetailInit }
      }
   }

   @action
   async cancelJob(id: number) {
      const response = await Request2.postWithToken({}, api.job.cancel + `/${id}`)
      if (!isEmpty(response)) {
         this.jobDetail = { ...jobDetailInit }
      }
   }

   @action
   async rateJob(jobID: string | number, rate: string | number, note?: string) {
      const body = { rate, note: note || '' }
      const DOMAIN = `${api.job.rate}/` + jobID
      // console.log('\nDOMAIN; ', DOMAIN, 'body', body)
      const result = await Request2.putWithToken(body, DOMAIN)
      // console.log('result; rateJob', JSON.stringify(result), '\nDOMAIN; ', DOMAIN)
      return result?.data
   }

   @action
   async assignJobToDesigner(designerId: any, jobId: any) {
      const result = await Request2.postWithToken({ designerId }, api.job.assignee + `/${jobId}`)
      console.log('result', result);

      return result?.data
   }
   @action
   async setJobPriority(jobId: any, isPriority: boolean) {
      const result = await Request2.postWithToken({ isPriority }, api.job.priority + `/${jobId}`)
      console.log('result', result);

      return result?.data
   }
   @action
   async countCancel() {
      const result = await Request2.getWithToken(api.job.countCancel)
      console.log('result', result);

      return result
   }
   @action
   async resetJobDetail() {
      this.jobDetail = { ...jobDetailInit }
      this.dirtyFields = []
   }
}
